export default "__VITE_ASSET__YPYVE0_5__"